import React, {Component} from 'react';
import {EditorState, convertFromRaw} from 'draft-js';
import Editor from 'draft-js-plugins-editor';

class DefaultContent extends Component {
  constructor(props){
    super(props);
    
    this.state = {
      editorState: EditorState.createEmpty()    
    }
  }

  componentDidMount() {
    this.getContent();
  }

  componentWillReceiveProps(newProps){
    if(this.props === newProps) { return; }

    this.props = newProps;
    this.getContent();

  }

  getContent(){
    let apiUrl = `${window.location.protocol}//${window.location.host}/api/default/wdelite`;
    fetch(apiUrl)
      .then(res => res.json())
      .then(data => {
        const doc = data[0];
        this.setState({
          title: doc.document.title,
          editorState: EditorState.createWithContent(convertFromRaw(doc.documentContent))
        });
      });
  }

  render(){
    return(
      <div className="editor-readonly-content">
        <h1>{this.state.title}</h1>
        <Editor
          name="displayEditor"
          editorState={this.state.editorState}  
          readOnly={true}
        />
      </div>
    );
  }
}

export default DefaultContent;